import { lazy } from 'react'
import { Route } from 'react-router-dom'
import { paths } from '../../paths'

export const budgetpage: JSX.Element[] = [
  <Route
    component={lazy(async () => {
      const { BudgetPage } = await import(
        /* webpackChunkName: "Login" */ '../../../components/pages/private/BudgetPage'
      )
      return {
        default: BudgetPage,
      }
    })}
    exact
    key={paths.budget}
    path={paths.budget}
  />,
]
